module.exports = __webpack_public_path__ + "static/ObjectSans-Heavy-79dee7c7ea3b21b7970003c820f500c1.otf";